@if ((consentsTranslations$ | async); as consentsTranslations) {
  @if (extendedCookieBanner) {
    <app-extended-cookie-consent [consentsTranslations]="consentsTranslations"/>
  } @else {
    <app-simple-cookie-consent [consentsTranslations]="consentsTranslations"/>
  }
}
